import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "../../../../languages/index.js";
import { SearchIcon } from "@heroicons/react/solid";
import _ from "lodash";
import Pagination from "react-js-pagination";
import { NotificationContainer } from "react-notifications";
import BaseLoader from "../../../../../common/base-loader";
import { fetchmasterTransaction, searchTransaction } from "../../actions/index";
import TransactionListing from "./transaction-items";
import TransactionmanagementTabs from "../transactiontabs";
import { classNames } from "../../../../../common/common-functions";

class MasterTransaction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deliveredorderSearch: "",
      loaderDesc: LocaleStrings.preparing_transaction,
      loading: true,
      pageNumber: 1,
      search: "",
    };

    // All Binded Functions
  }

  componentDidMount() {
    this.props.fetchmasterTransaction(
      this.props.session,
      0,
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );
  }

  handleSearch = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    if (search == "") {
      this.props.fetchmasterTransaction(
        this.props.session,
        0,
        (CallBackResponse) => {}
      );
    } else {
      this.props.searchTransaction(this.props.session, search);
    }
    this.setState({ search, pageNumber });
  };

  paginationCallback = (pageNumber) => {
    //  console.log("pgno", pageNumber)
    if (this.state.search == "") {
      this.props.fetchmasterTransaction(
        this.props.session,
        pageNumber,
        (response) => {}
      );
    } else {
      this.props.searchTransaction(
        this.props.session,
        this.state.search,
        pageNumber
      );
    }

    this.setState({ ...this.state, pageNumber });
  };

  rendervariationList() {
    let pageDataLength = this.props.alltransactions.data.length;

    let { pageNumber } = this.state;

    var items = _.map(this.props.alltransactions.data, (values, index) => (
      <TransactionListing
        key={index}
        values={values}
        pagination={this.paginationCallback}
        pageDataLength={pageDataLength}
        currentPage={pageNumber}
      />
    ));
    return items;
  }

  render() {
    let { language } = this.props;
    // console.log('alltransactions',this.props.alltransactions)
    return (
      <>
        <TransactionmanagementTabs history={this.props.history} />
        {this.state.loading ? (
          <>
            <BaseLoader data={this.state.loaderDesc} />
          </>
        ) : (
          <>
            <div
              className="grid gap-4 grid-rows-1 px-6 md:grid-rows-3 sm:grid-rows-3 lg:grid-rows-1 "
              style={{
                overflowX: "hidden",
                overflowY: "hidden",
                display: "block",
              }}>
              <div className="relative md:w-6/12 xs:w-full text-ternary focus-within:text-secondary smallscreen-search mt-6">
                <div
                  className={classNames(
                    language == "en" ? "left-0 " : "right-0",
                    "absolute inset-y-0 flex items-center pointer-events-none px-1"
                  )}>
                  <SearchIcon className="h-5 w-5" aria-hidden="true" />
                </div>
                <input
                  id="search-field"
                  className={classNames(
                    language == "en" ? "pl-8 pr-3" : "pr-8 pl-3",
                    "block lg:w-6/12 xs:w-full sm:w-full h-full  py-2 border-transparent text-secondary placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm rounded-md"
                  )}
                  placeholder="Search by Transaction id"
                  type="search"
                  name="search"
                  value={this.state.search}
                  onChange={this.handleSearch}
                />
              </div>
            </div>
            {_.isEmpty(this.props.alltransactions.data) ? (
              <>
                <div className="center-item lg:mt-48 text-lg text-ternary">
                  {LocaleStrings.transaction_th_noData}
                </div>
              </>
            ) : (
              <>
                <div className="flex flex-col pt-6 pb-2 px-6">
                  <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                      <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-custWhite">
                            <tr>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.transaction_th_transactionid}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.transaction_th_payementmode}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.transaction_th_paymenetstatus}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.transaction_th_amount}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.transaction_th_transactiontype}
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {LocaleStrings.transaction_th_paymentby}
                              </th>
                            </tr>
                          </thead>
                          <tbody>{this.rendervariationList()}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <Pagination
                  activePage={this.state.pageNumber}
                  itemsCountPerPage={10}
                  totalItemsCount={this.props.alltransactions.count}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                />
              </>
            )}
          </>
        )}

        <NotificationContainer />
      </>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, language } = state;
  // console.log('state.specificationlisting',state.specificationlisting)
  return {
    session,
    user,
    language,
    alltransactions: state.alltransactions,
  };
}

export default connect(mapStateToProps, {
  fetchmasterTransaction,
  searchTransaction,
})(MasterTransaction);
